export const EVENTS = {
  OPEN_INFORMATION: 'sms:open',
  SUBSCRIPTION_UPDATED: 'sms:subscription-updated',
};
